import { format } from "lib/globalize-util";
import _ from "lodash";

/** Any input under this length is treated as OK input */
const ACCEPTABLE_INPUT_LENGTH = 128;
export const MAX_MEANINGFUL_WORDS = 30;
export const MAX_PATTERN_WORDS = 2000;
/** Max number of different word lengths to be treated as not free input */
export const FEW_WORD_CLASSES = 7;
export const MAX_WORD_CLASSES = 15;
/** Max length of a word to be treated as a free input. Max observed length is 22 */
export const MAX_WORD_LENGTH = 50;

export default function validateBulkSearch(words: string[]): string {
    const hasLongWords = _.some(words, (word) => word.length > MAX_WORD_LENGTH);
    if (words.join("").length <= ACCEPTABLE_INPUT_LENGTH && !hasLongWords) {
        return "";
    }

    const hasTooManyWords = words.length > MAX_PATTERN_WORDS;
    const hasFewWords = words.length <= MAX_MEANINGFUL_WORDS;

    // Technical limitation
    if (hasTooManyWords) {
        return format("Bulk Search is limited by |limit| values", { limit: MAX_PATTERN_WORDS });
    }

    const classes = _.size(_.groupBy(words, "length"));
    const hasTooManyClasses = classes > MAX_WORD_CLASSES;
    const hasFewClasses = classes <= FEW_WORD_CLASSES;

    // meaningful phrase or pattern input
    const isFreeInput = hasLongWords || hasTooManyClasses;
    if (!isFreeInput && (hasFewWords || hasFewClasses)) {
        return "";
    }

    return format(
        "Your search term(s) looks like free input (long words or illogical). Adjust your search and try again."
    );
}
